'use client';

import { createContext } from 'react';

import type {
  AccordionRootActionsContextInterface,
  AccordionRootContextInterface,
  AccordionRootStateContextInterface,
} from '../types/accordion-root.types';

/**
 * Legacy combined context kept to avoid breaking the public AccordionRootContext export.
 * Accordion internals should use the split state/actions contexts; remove in v11.
 */
export const AccordionRootContext = createContext<AccordionRootContextInterface>({});

AccordionRootContext.displayName = 'Accordion.Root.Context';

export const AccordionRootStateContext = createContext<AccordionRootStateContextInterface>({});

AccordionRootStateContext.displayName = 'Accordion.Root.State.Context';

export const AccordionRootActionsContext = createContext<AccordionRootActionsContextInterface>({});

AccordionRootActionsContext.displayName = 'Accordion.Root.Actions.Context';
